// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yrefH","colMin":"styles_colMin__2QzAk"};